import { useTranslation } from 'react-i18next';
import { FormSection } from '../../form-section';
import { ProfileTextField } from '../profile-text-field';
import { type DoctorProfileFormMode, isFieldVisible } from '../types';
import type { DoctorProfileUseForm } from '../use-doctor-profile-form';

/**
 * "Banque et outils" section: IBAN, BIC, commission rate and Doctolib id.
 *
 * @param props.form - the unified profile form
 * @param props.mode - the form mode driving field visibility
 * @param props.financialsDisabled - read-only bank and commission fields for this viewer
 * @returns the section
 */
export const BankingToolsSection = ({
  form,
  mode,
  financialsDisabled,
}: {
  form: DoctorProfileUseForm;
  mode: DoctorProfileFormMode;
  financialsDisabled: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t('edit-user-profile-form.section.banking-tools')}>
      <ProfileTextField
        form={form}
        name="iban"
        labelKey="edit-user-profile-form.iban.label"
        disabled={financialsDisabled}
      />
      <ProfileTextField
        form={form}
        name="bic"
        labelKey="edit-user-profile-form.bic.label"
        disabled={financialsDisabled}
      />
      {isFieldVisible(mode, 'commission') && (
        <ProfileTextField
          form={form}
          name="commissionRate"
          type="number"
          labelKey="add-office-attending-doctor-form.commission-rate.label"
          placeholderKey="add-office-attending-doctor-form.commission-rate.placeholder"
          disabled={financialsDisabled}
        />
      )}
      {isFieldVisible(mode, 'doctolibId') && (
        <ProfileTextField
          form={form}
          name="doctolibId"
          labelKey="add-office-attending-doctor-form.doctolib-id.label"
          placeholderKey="add-office-attending-doctor-form.doctolib-id.placeholder"
        />
      )}
    </FormSection>
  );
};
